/**
 * 姿态关键点工具：虚拟点计算、自定义骨骼连线。
 */

/** 自定义骨骼连线（含虚拟关键点 17、18） */
export const CUSTOM_SKELETON_PAIRS = [
  [0, 17], [17, 6], [6, 8], [8, 10],
  [17, 5], [5, 7], [7, 9],
  [17, 18], [18, 12], [12, 14], [14, 16],
  [18, 11], [11, 13], [13, 15],
];

/** 计算两关键点之间的中点，置信度取两者较小值 */
export function midpoint(kpA, kpB) {
  if (kpA == null || kpB == null) {
    return null;
  }
  const scoreA = kpA.score != null ? kpA.score : 1;
  const scoreB = kpB.score != null ? kpB.score : 1;
  return {
    x: (kpA.x + kpB.x) / 2,
    y: (kpA.y + kpB.y) / 2,
    score: Math.min(scoreA, scoreB),
  };
}

/** 在原始 17 个关键点基础上追加虚拟点 17（肩中点）、18（髋中点） */
export function buildKeypointsWithVirtual(keypoints) {
  const extended = keypoints.slice();
  extended[17] = midpoint(keypoints[6], keypoints[5]);
  extended[18] = midpoint(keypoints[12], keypoints[11]);
  return extended;
}

/**
 * 摄像头坐标系下的躯干中心（肩中点与髋中点再取中）。
 */
export function getTorsoCenterVideo(keypoints, scoreThreshold = 0) {
  const extended = buildKeypointsWithVirtual(keypoints);
  const shoulder = extended[17];
  const hip = extended[18];
  if (shoulder == null && hip == null) {
    return null;
  }
  if (shoulder == null) {
    return scoreOk(hip, scoreThreshold) ? {x: hip.x, y: hip.y} : null;
  }
  if (hip == null) {
    return scoreOk(shoulder, scoreThreshold) ? {x: shoulder.x, y: shoulder.y} :
        null;
  }
  if (!scoreOk(shoulder, scoreThreshold) && !scoreOk(hip, scoreThreshold)) {
    return null;
  }
  return {
    x: (shoulder.x + hip.x) / 2,
    y: (shoulder.y + hip.y) / 2,
  };
}

function scoreOk(kp, threshold) {
  const score = kp.score != null ? kp.score : 1;
  return score >= threshold;
}
